<template>
  <div>
    <v-text-field
      ref="textField"
      v-model="internalValue.job_id"
      :autofocus="$attrs.autofocus"
      :disabled="$attrs.disabled"
      :required="$attrs.required"
      dense
      clearable
      class="font-weight-medium text-body-1"
      :rules="prepRules()"
      @blur="onBlur(internalValue)"
      @click="input_onClick"
    >
      <template v-slot:label>
        <v-icon
          v-if="$attrs.required"
          class="required-icon"
          x-small
        >
          mdi-asterisk
        </v-icon>
        {{ $attrs.label }}
      </template>
    </v-text-field>
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'
  import { mapGetters } from 'vuex'

  export default {
    name: 'JobNumber',

    props: {
      value: {
        type: Object,
        default: null,
      },
    },

    data () {
      return {
        internalValue: this.value,
      }
    },

    computed: {
      ...mapGetters('app', [
        'getDataById',
      ]),
      appRules: get('app/rules'),
    },

    watch: {
      internalValue: {
        handler (val, oldVal) {
          if (val.job_id === oldVal.job_id) return

          this.$emit('input', this.internalValue)
        },
        deep: true,
      },
      value: {
        handler (val, oldVal) {
          if (val.job_id === oldVal.job_id) return

          this.internalValue = val
        },
        deep: true,
      },
    },

    methods: {
      prepareToUpdate (dataItem) {
        if (!dataItem.updated) {
          const originalData = this.getDataById(this.$attrs.originalData, dataItem.id)
          if (originalData.length > 0) {
            if (dataItem.job_id !== originalData[0].job_id) {
              this.$store.dispatch('user/setStateAsUpdated', dataItem)
            }
          }
        }
        this.$nextTick(() => {
          this.$emit('change', dataItem)
        })
      },

      onBlur (dataItem) {
        this.prepareToUpdate(dataItem)
      },

      prepRules () {
        if (this.$attrs.required && !this.$attrs.disabled) {
          return [this.appRules.required]
        } else {
          return []
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .required-icon {
    vertical-align: top;
    color: #dd0000;
  }
</style>
